import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const ImagePopup = ({ isVisible, onClose, imageUrl, redirectUrl }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = "hidden";
      // Reset image loaded state when popup becomes visible
      setImageLoaded(false);
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isVisible]);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleImageClick = () => {
    if (redirectUrl) {
      window.open(redirectUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isVisible) return null;

  return createPortal(
    <div className="image-popup" >
      <div className="image-popup__container">
        <div 
          className={`image-popup__content ${imageLoaded ? 'image-popup__content--loaded' : ''}`}
          onClick={handleImageClick}
        >
          <button 
            className="image-popup__close" 
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            aria-label="Close popup"
            style={{ opacity: imageLoaded ? 1 : 0 }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <img 
            src={imageUrl} 
            alt="Popup" 
            onLoad={handleImageLoad}
            style={{ opacity: imageLoaded ? 1 : 0 }}
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ImagePopup;
